// src/components/archive_post/news_item.js

import React from "react";
import Link from "next/link";
import Image from "next/image";
import ReactHtmlParser from "html-react-parser";

const NewsItem = ({
  data,
  classes = "grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3",
}) => {
  return (
    <div className={classes}>
      {data.map((article) => {
        const { id, personalImages, title, content, createdAt } = article;
        return (
          <article key={id}>
            <div className="rounded-2xl overflow-hidden transition-shadow hover:shadow-lg">
              {/* Image Section */}
              <figure className="group max-h-96 overflow-hidden">
                <Link href={`/archive_post/${id}`}>
                  <a>
                    <Image
                      src={personalImages[0] || "/images/default.jpg"} // Display the first personal image or a default
                      alt={title}
                      width={400}
                      height={250}
                      className="h-full w-full object-cover transition-transform duration-300 ease-in-out transform group-hover:scale-105"
                      layout="responsive"
                      priority
                    />
                  </a>
                </Link>
              </figure>

              {/* Body Section */}
              <div className="dark:border-jacarta-600 dark:bg-jacarta-700 border-jacarta-100 rounded-b-2xl border-t-0 bg-white p-6">
                {/* Title */}
                <h2 className="font-display text-jacarta-700 dark:hover:text-green hover:text-green mb-4 text-xl dark:text-white">
                  <Link href={`/archive_post/${id}`}>
                    <a>{title}</a>
                  </Link>
                </h2>

                {/* Excerpt */}
                <p className="dark:text-jacarta-200 mb-4">
                  {ReactHtmlParser(content.substring(0, 100) || "")}
                  {content.length > 100 && "..."}
                </p>

                {/* Date */}
                {createdAt && (
                  <div className="text-jacarta-400 flex items-center space-x-2 text-sm mb-4">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-4 w-4"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                      />
                    </svg>
                    <time>
                      {createdAt
                        ? new Date(createdAt.toDate()).toLocaleDateString()
                        : ""}
                    </time>
                  </div>
                )}

                {/* View Detail Blog Button */}
                <div>
                  <Link href={`/archive_post/${id}`}>
                    <a className="inline-block rounded bg-green py-2 px-4 text-sm font-semibold text-white hover:bg-green-dark transition-colors duration-300">
                      View Detail Blog
                    </a>
                  </Link>
                </div>
              </div>
            </div>
          </article>
        );
      })}
    </div>
  );
};

export default NewsItem;
